import { render, staticRenderFns } from "./ChangeCoverModal.vue?vue&type=template&id=4a4d74fe&scoped=true"
import script from "./ChangeCoverModal.vue?vue&type=script&lang=js"
export * from "./ChangeCoverModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeCoverModal.vue?vue&type=style&index=0&id=4a4d74fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4d74fe",
  null
  
)

export default component.exports